import React from 'react';
import { MDBCard, MDBCardBody } from 'mdbreact';
import { formataNumero, formataPct } from './formata';

// Número grande + rótulo; com `total`, mostra a fatia em %.
// `formata` troca a formatação do número (ex.: reais); `detalhe` é uma linha
// miúda abaixo do rótulo; `comparacao` é a linha do período anterior.
// `compacto` reduz o número e o mantém numa linha ("R$ 365,1 mi" quebrava em
// cinco cards lado a lado).
export default function KpiTile({
  valor, rotulo, total, cor, formata = formataNumero, detalhe, comparacao, compacto,
}) {
  return (
    <MDBCard className="h-100">
      <MDBCardBody className="text-center p-3">
        <div
          style={{
            fontSize: compacto ? '1.6rem' : '2rem',
            fontWeight: 600,
            lineHeight: 1.1,
            color: cor || 'inherit',
            whiteSpace: compacto ? 'nowrap' : undefined,
          }}
        >
          {formata(valor)}
        </div>
        <div className="text-muted" style={{ fontSize: '.85rem' }}>
          {rotulo}
          {total ? ` · ${formataPct(valor, total)}` : ''}
        </div>
        {detalhe ? <div className="text-muted" style={{ fontSize: '.75rem' }}>{detalhe}</div> : null}
        {comparacao ? <div style={{ fontSize: '.78rem', marginTop: '.25rem' }}>{comparacao}</div> : null}
      </MDBCardBody>
    </MDBCard>
  );
}
